import { Mapper } from "../../../../base/utils/mapper";
import { DocumentSystemGenerateModel } from "../../../../domain/models/certificate/document-system-generate.model";
import { DocumentSystemGenerateEntity } from "../entities/document-system-generate.entity";

export class DocumentSystemGenerateImplementationRepositoryMapper
  extends Mapper<
    DocumentSystemGenerateEntity,
    DocumentSystemGenerateModel
  > {

  mapFrom(param: DocumentSystemGenerateEntity): DocumentSystemGenerateModel {
    return {
      ...param,
      data: Array.isArray(param?.data)
        ? param.data
        : param?.data
          ? [param.data]
          : []
    };
  }

  mapTo(param: DocumentSystemGenerateModel): DocumentSystemGenerateEntity {
    return {
      ...param
    };
  }
}